export const META_PIXEL_TRACKED_PATHS = [
  "/login",
  "/estimate-earnings",
] as const;

export const META_ATTRIBUTION_STORAGE_KEY = "artha_meta_attribution";
export const FBC_COOKIE_NAME = "_fbc";
export const FBP_COOKIE_NAME = "_fbp";
export const FBCLID_PARAM = "fbclid";
export const FBC_PARAM = "_fbc";
export const FBP_PARAM = "_fbp";

export const META_SOURCE_REGEX = /^(facebook|meta|instagram|fb)$/i;

// 90 days in seconds (Meta's standard cookie lifetime for _fbc)
export const META_COOKIE_MAX_AGE_SECONDS = 90 * 24 * 60 * 60;

export const META_PIXEL_SCRIPT_URL =
  "https://connect.facebook.net/en_US/fbevents.js";
